import { checkTestExists } from "@utils/api-communication/RestApiCli";

export class TestCompletionService {
  private static instance: TestCompletionService;
  private checkedTestIds = new Set<string>(); // Prevent duplicate checks

  static getInstance(): TestCompletionService {
    if (!TestCompletionService.instance) {
      TestCompletionService.instance = new TestCompletionService();
    }
    return TestCompletionService.instance;
  }

  /**
   * Check if test exists in backend (meaning it's completed)
   */
  async checkBackendTestCompletion(testId: string): Promise<boolean> {
    if (this.checkedTestIds.has(testId)) {
      return false;
    }
    this.checkedTestIds.add(testId);
    try {
      const response = await new Promise((resolve, reject) => {
        checkTestExists(
          { uuid: testId },
          (response) => {
            resolve(response);
          },
          (error) => {
            console.error(`Error fetching test data for ${testId}:`, error);
            reject(error);
          },
        );
      });

      const exists = !!(response as any)?.data?.exists;

      if (!exists) {
        // If test does not exist, remove from checked set to allow future checks
        this.checkedTestIds.delete(testId);
      }
      return exists;
    } catch (error) {
      console.error("Error checking backend test completion:", error);
      // Remove from checked set on error so we can retry
      this.checkedTestIds.delete(testId);
      return false;
    }
  }

  /**
   * Reset checked test IDs (call when starting new test)
   */
  async forceCheckBackendTestCompletion(testId: string): Promise<boolean> {
    this.checkedTestIds.delete(testId);
    return this.checkBackendTestCompletion(testId);
  }

  resetCheckedTests(): void {
    this.checkedTestIds.clear();
  }
}
